import React, { RefObject } from 'react';
import styled from 'styled-components';

import {
  Social,
  Navigate,
  HeaderMobile,
  HiddenSeoData,
  HeaderDesktop,
} from '@components/molecules';
import useDevice from '@hooks/useDevice';
import { Container, ContentContainer } from '@components/atoms';
import { socialNavigation } from '@shared/constants/navigate';

type HeaderProps = {
  refs: RefObject<HTMLDivElement>[];
};

function Header({ refs }: HeaderProps) {
  const { isMobile, isLaptop, isDesktop, isTablet } = useDevice();

  return (
    <StyledHeader $isMobile={isMobile} $isTablet={isTablet}>
      <Container>
        {(isTablet || isMobile) && <HeaderMobile refs={refs} />}
        {(isLaptop || isDesktop) && (
          <ContentContainer>
            <HeaderDesktop refs={refs} />
          </ContentContainer>
        )}

        <HiddenSeoData>
          <h1>Greenline Logistics</h1>
          <Navigate ariaLabel="Site navigation" />
          <Social
            ariaLabel="Contact and social links"
            links={socialNavigation}
          />
        </HiddenSeoData>
      </Container>
    </StyledHeader>
  );
}

const StyledHeader = styled.header<{ $isMobile: boolean; $isTablet: boolean }>`
  width: 100%;
  height: ${({ $isMobile }) => ($isMobile ? '66px' : '98px')};
  position: fixed;

  background-color: ${({ theme }) => theme.colors.athensGray};

  z-index: 3;
`;

export default Header;
